import React from 'react';
import ManCrossPageFooter from '../components/ManCrossPageFooter';

const LEGAL_SECTIONS = [
    {
        title: 'Propósito exclusivamente preventivo',
        body:  'Los resultados de IASH e IPRA son instrumentos de analítica predictiva para la gestión del riesgo en SST. No constituyen evaluación de desempeño laboral, calificación individual, ni fundamento para decisiones disciplinarias, salariales o de vinculación.',
    },
    {
        title: 'Responsabilidad por uso',
        body:  'El uso, interpretación, comunicación interna y aplicación de los resultados es responsabilidad exclusiva de la organización cliente. Talentha® entrega los análisis como insumo técnico. No responde por consecuencias derivadas de un uso que contravenga esta declaración.',
    },
    {
        title: 'Confiabilidad de la muestra',
        body:  'Resultados de áreas con cobertura < 60% se presentan con advertencia explícita y se excluyen de análisis comparativos. Las probabilidades predictivas son estimaciones basadas en modelos estadísticos — no garantías absolutas.',
    },
    {
        title: 'Propiedad intelectual',
        body:  'Los instrumentos IASH e IPRA, la metodología IVC, los modelos de scoring, los pesos ponderados, los marcos analíticos y todo desarrollo intelectual son propiedad exclusiva de Mentoring Consultores SAS (Talentha®), con registro ante la DNDA en proceso.',
    },
    {
        title: 'Confidencialidad',
        body:  'Este informe es de uso interno exclusivo del área de SST y Gerencia. Su reproducción, distribución o publicación parcial o total requiere autorización escrita previa de Talentha®. Los datos de trabajadores se tratan conforme a Ley 1581 de 2012.',
    },
];

const ManCrossPageLegal = ({ reportData, headerText, pageNumber }) => {
    const year = reportData?.created_at
        ? new Date(reportData.created_at).getFullYear()
        : new Date().getFullYear();

    return (
        <div className="mgcr-legal-page">
            <div className="mgcr-page-header">
                <span className="mgcr-page-header-text">{headerText}</span>
                <span className="mgcr-page-header-num">{pageNumber}</span>
            </div>

            <div className="keep-blankspace" />

            <div className="mgcr-dx-title-area">
                <h2 className="mgcr-dx-main-title">Marco Legal</h2>
                <p  className="mgcr-dx-subtitle">Notas Metodológicas</p>
            </div>

            <div className="mgcr-legal-sections">
                {LEGAL_SECTIONS.map((s, i) => (
                    <div key={i} className="mgcr-legal-section">
                        <p className="mgcr-legal-section-title">{s.title}</p>
                        <p className="mgcr-legal-section-body">{s.body}</p>
                    </div>
                ))}
            </div>

            <div className="mgcr-legal-year">
                Talentha® · Mentoring Consultores SAS · {year}
            </div>

            <div className="keep-blankspace" />
            <ManCrossPageFooter />
        </div>
    );
};

export default ManCrossPageLegal;
